module.exports = __webpack_public_path__ + "img/settings.ea0605eb.svg";